// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacmyappIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacmyappIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacmyappIconOutlined = function DrrpDacmyappIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacmyappIconOutlinedSvg
  }));
};

DrrpDacmyappIconOutlined.displayName = 'DrrpDacmyappIconOutlined';
export default React.forwardRef(DrrpDacmyappIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacmyappIconOutlined.js
// module id = 2510
// module chunks = 0